<template>
    <div class="sing_month">
        <ul class="week_header">
            <li class="h_item" v-for="wk in weekHeader">{{wk}}</li>
        </ul>
        <ul class="month_content">
            <li class="day_item" v-for="p in getPreMonthDay">
                <div class="day_num no_the_month">
                    <strong>{{preMonthLastDay - getPreMonthDay + p}}</strong>
                    <p v-if="month==1">{{getLunarDay(year - 1, 12, preMonthLastDay - getPreMonthDay + p)}}</p>
                    <p v-else>{{getLunarDay(year, month - 1, preMonthLastDay - getPreMonthDay + p)}}</p>
                </div>
            </li>
            <li class="day_item" v-for="(cur,index) in currentMonthLastDay"
                :class="{current:cur==today&&curYear==year&&month==curMonth}" @mouseenter="planDetailFun('hover',index)"
                @mouseleave="planDetailFun('leave',index)">
                <div class="day_num">
                    <strong>{{cur}}</strong>
                    <p>{{getLunarDay(year, month, cur)}}</p>
                </div>
                <template v-if="holidayPlan&&holidayPlan.hasOwnProperty(year+'-'+month+'-'+cur)">
                        <a class="plan_item" target="_blank" :ref="'holidayPlan_'+index"
                           v-for="(plan,pindex) in getCurHolidayPlan(year+'-'+month+'-'+cur)"
                           :style="{'background-color':plan.bgColor,'bottom':planBottomPlus*pindex+'px','z-index':getCurHolidayPlan(year+'-'+month+'-'+cur).length-pindex}"
                           v-if="plan.state=='未计划'||plan.state=='未关怀'"
                           :href="getBirthdayTopicUrl+'cat_id='+plan.cat_id">
                            <span class="holiday">{{plan.name}}</span>
                            <span class="status">{{plan.state}}</span>
                        </a>
                        <a v-if="plan.state=='已计划'||plan.state=='已完成'" class="plan_item" target="_blank"
                           :ref="'holidayPlan_'+index"
                           v-for="(plan,pindex) in getCurHolidayPlan(year+'-'+month+'-'+cur)"
                           :style="{'background-color':plan.bgColor,'bottom':planBottomPlus*pindex+'px','z-index':getCurHolidayPlan(year+'-'+month+'-'+cur).length-pindex}"
                           :href="getCareDetailUrl+'plan_id='+plan.plan_id">
                            <span class="holiday">{{plan.name}}</span>
                            <span class="status">{{plan.state}}</span>
                        </a>



                </template>

            </li>
            <li class="day_item" v-for="n in getNextMonthDay">
                <div class="day_num no_the_month">
                    <strong>{{n}}</strong>
                    <p v-if="month==12">{{getLunarDay(year + 1, 1, n)}}</p>
                    <p v-else>{{getLunarDay(year, month + 1, n)}}</p>
                </div>
            </li>
        </ul>
    </div>
</template>
<script type="text/javascript">
    import {
        mapGetters,
        mapActions
    } from 'vuex'

    export default {
        props: {
            year: null,
            month: null
        },
        data() {
            return {
                weekHeader: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
                planBottomPlus: 6,
                planItemHeight: 24,//24 本身的高，1像素border
                planBgColor: ['#fe7678', '#58d2f9', '#dcdcdc'],//0 未计划，1已计划，2已完成
                today: new Date().getDate(),
                curYear: new Date().getFullYear(),
                curMonth: new Date().getMonth() + 1
            }
        },
        components: {},
        computed: {
            ...mapGetters({
                holidayPlan: 'getHolidayPlan'
            }),
            getPreMonthDay() {
                let weekday = this.$calendar.solar2lunar(this.year, this.month, 1).ncWeek;
                let spanDay = 0;
                switch (weekday) {
                    case "星期日":
                        spanDay = 0;
                        break;
                    case "星期一":
                        spanDay = 1;
                        break;
                    case "星期二":
                        spanDay = 2;
                        break;
                    case "星期三":
                        spanDay = 3;
                        break;
                    case "星期四":
                        spanDay = 4;
                        break;
                    case "星期五":
                        spanDay = 5;
                        break;
                    case "星期六":
                        spanDay = 6;
                        break;
                }
                console.log("spanDay", weekday, spanDay)
                return spanDay;
            },
            preMonthLastDay() {
                let lastDay = null;
                if (this.month == 1) {
                    lastDay = this.getLastDay(this.year - 1, 12)
                } else {
                    lastDay = this.getLastDay(this.year, this.month - 1)
                }
                console.log('preMonthLastDay', lastDay)
                return lastDay;
            },
            currentMonthLastDay() {
                return this.getLastDay(this.year, this.month);
            },
            getNextMonthDay() {
                console.log("nex", this.getPreMonthDay + this.currentMonthLastDay)
                let day = 0;
                if ((this.getPreMonthDay + this.currentMonthLastDay) % 7 != 0) {
                    day = 7 - (this.getPreMonthDay + this.currentMonthLastDay) % 7
                }
                return day;
            },
            getUrls() {
                console.log("agh", agho)
                let prefix = '/AiGuanHuai/';
                let urlObj = {}
                console.log("agho.urls", agho.urls)
                if (agho.urls) {
                    if (agho.urls.hasOwnProperty('agh/pop/birthdayTopic')) {
                        urlObj.birthdayTopic = agho.urls['agh/pop/birthdayTopic']
                        if (urlObj.birthdayTopic.split('?')[1]) {
                            urlObj.birthdayTopicParams = true;
                        }
                    } else {
                        urlObj.birthdayTopic = prefix + 'agh/pop/birthdayTopic'
                    }
                    if (agho.urls.hasOwnProperty('agh/pop/careDetail')) {
                        urlObj.careDetail = agho.urls['agh/pop/careDetail']
                        if (urlObj.careDetail.split('?')[1]) {
                            urlObj.careDetailParams = true;
                        }
                    } else {
                        urlObj.careDetail = prefix + 'agh/pop/careDetail'
                    }
                } else {
                    urlObj.birthdayTopic = prefix + 'agh/pop/birthdayTopic'
                    urlObj.careDetail = prefix + 'agh/pop/careDetail'
                }
                console.log('urlObj', urlObj)
                return urlObj;
            },
            getBirthdayTopicUrl() {
                return this.getUrls.birthdayTopicParams ? this.getUrls.birthdayTopic + '&' : this.getUrls.birthdayTopic + '?'
            },
            getCareDetailUrl() {
                return this.getUrls.careDetailParams ? this.getUrls.careDetail + '&' : this.getUrls.careDetail + '?'
            }
        },
        watch: {
            holidayPlan(cval) {
                console.log("holidayPlan", cval);
            },
            year(cval) {
                let params = {
                    type: 0,
                    value: `${this.year}-${this.month}`
                }
                this.$store.dispatch('loadHolidayPlan', params)
            },
            month(cval) {
                let params = {
                    type: 0,
                    value: `${this.year}-${this.month}`
                }
                this.$store.dispatch('loadHolidayPlan', params)
            }
        },
        created() {
            let params = {
                type: 0,
                value: `${this.year}-${this.month}`
            }
            this.$store.dispatch('loadHolidayPlan', params)
        },
        methods: {
            planDetailFun(type, index) {
                let $el = this.$refs['holidayPlan_' + index];
                if (!$el || $el.length <= 0) {
                    return false;
                }
                if (type == 'hover') {
                    $el.forEach((item, elIndex, arr) => {
                        let length = arr.length;
                        let zIndex=item.style.zIndex;
                        // console.log("elIndex",item.style.zIndex)
                        item.style.bottom = this.planItemHeight * (length - zIndex) + 'px';
                    })
                } else {
                    $el.forEach((item, elIndex, arr) => {
                        let length = arr.length;
                        let zIndex=item.style.zIndex;
                        item.style.bottom = this.planBottomPlus * (length - zIndex) + 'px';
                    })
                }
                // let target =event.target;
                // console.log("hover",target,index)
                // if(index>0){
                //     console.log("hoverbottom",this.planItemHeight*index+'px')
                //     target.style.bottom=this.planItemHeight*index+'px';
                // }

            },
            getLastDay(year, month) {
                var new_year = year;    //取当前的年份
                var new_month = month++;//取下一个月的第一天，方便计算（最后一天不固定）
                if (month > 12)            //如果当前大于12月，则年份转到下一年
                {
                    new_month -= 12;        //月份减
                    new_year++;            //年份增
                }
                var new_date = new Date(new_year, new_month, 1);                //取当年当月中的第一天
                return (new Date(new_date.getTime() - 1000 * 60 * 60 * 24)).getDate();//获取当月最后一天日期
            },
            getLunarDay(year, month, day) {
                return this.$calendar.solar2lunar(year, month, day).IDayCn;
            },
            getCurHolidayPlan(key) {
                console.log('key----', key)
                console.log("getCurHoliday", this.holidayPlan.hasOwnProperty(key))
                console.log('this.holidayPlan[key].scenes;', this.holidayPlan[key].scenes)
                if (this.holidayPlan && this.holidayPlan.hasOwnProperty(key)) {
                    return this.holidayPlan[key].scenes;
                } else {
                    return []
                }

            }

        },
        mounted() {
            //  let date=  this.$calendar.solar2lunar(this.year,this.month,16);
            // console.log("当前日期信息",date)

        }
    }
</script>
<style lang="scss">
    $borderColor: #e1e1e1;
    %clearfix {
        display: table;
        clear: both;
        content: "";
    }

    .sing_month {
        padding-bottom: 30px;
        .week_header {
            border-bottom: 1px solid $borderColor;
            &:after {
                @extend %clearfix;
            }
            .h_item {
                float: left;
                width: 14.28%;
                padding: 14px 0;
                text-align: center;
                font-size: 13px;
                color: #999;
                border-right: 1px solid $borderColor;
                &:last-child {
                    border-right: none;
                }
            }
        }
        .month_content {
            &:after {
                @extend %clearfix;
            }
        }
        .day_item {
            float: left;
            width: 14.28%;
            height: 102px;
            padding-top: 6px;
            text-align: center;
            position: relative;
            border-bottom: 1px solid $borderColor;
            border-right: 1px solid $borderColor;
            // cursor:pointer;
            // &:hover{
            //     background-color:#f6f6f6;
            // }
            &.current {
                background-color: #f6f6f6;
            }
            &:nth-of-type(7n) {
                border-right: none;
            }
            .day_num {
                color: #333;
                strong {
                    font-size: 20px;
                    font-weight: normal;
                }
                p {
                    font-size: 14px;
                }
                &.no_the_month {
                    color: #cdcdcd;
                }
            }
            .plan_item {
                display: block;
                position: absolute;
                width: 100%;
                height: 24px;
                line-height: 24px;
                padding: 0 8px;
                bottom: 0;
                color: #fff;
                cursor: pointer;
                border-top: 1px solid #fff;
                &:after {
                    @extend %clearfix;
                }
                .holiday {
                    float: left;
                    width: 50%;
                    overflow: hidden;
                    text-align: left;
                }
                .status {
                    float: right;
                    width: 50%;
                    overflow: hidden;
                    text-align: right;
                }
            }
        }
    }

</style>	
